var _rect, _rect2, _circle, _text, _rect3, _rect4, _text2, _text3, _text4, _text5, _text6, _text7, _rect5, _text8, _text9, _rect6, _text10, _text11, _rect7, _text12, _text13, _rect8, _text14, _rect9, _text15, _text16, _text17, _text18, _text19, _rect10, _text20, _text21, _text22, _rect11, _text23, _text24, _text25, _rect12, _text26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCognitoScreenshot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 800,
    fill: "#f8fafc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 64,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 32,
    r: 24,
    fill: "#4338ca"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#1e293b"
  }, "Cognito")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 64,
    width: 240,
    height: 736,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 96,
    width: 200,
    height: 40,
    rx: 6,
    fill: "#eef2ff"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#4338ca"
  }, "Dashboard")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 180,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#64748b"
  }, "Jobs")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 220,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#64748b"
  }, "Candidates")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 260,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#64748b"
  }, "Interviews")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 300,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#64748b"
  }, "Analytics")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#1e293b"
  }, "Dashboard")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 160,
    width: 220,
    height: 120,
    rx: 8,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 190,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#64748b"
  }, "Active Jobs")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 230,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#1e293b"
  }, "24")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 160,
    width: 220,
    height: 120,
    rx: 8,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 190,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#64748b"
  }, "Total Candidates")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 230,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#1e293b"
  }, "847")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 160,
    width: 220,
    height: 120,
    rx: 8,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 190,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#64748b"
  }, "Interviews This Week")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 230,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#1e293b"
  }, "12")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 320,
    width: 700,
    height: 400,
    rx: 8,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 360,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#1e293b"
  }, "Recent Applications")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 380,
    width: 700,
    height: 40,
    fill: "#f8fafc"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 405,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#64748b"
  }, "NAME")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 405,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#64748b"
  }, "POSITION")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 405,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#64748b"
  }, "STATUS")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 445,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#1e293b"
  }, "Sarah Johnson")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 445,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#1e293b"
  }, "Senior Developer")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 430,
    width: 80,
    height: 24,
    rx: 12,
    fill: "#dbeafe"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 740,
    y: 445,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#2563eb",
    textAnchor: "middle"
  }, "Review")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 485,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#1e293b"
  }, "Michael Chen")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 485,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#1e293b"
  }, "Product Manager")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 470,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#dcfce7"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 485,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#16a34a",
    textAnchor: "middle"
  }, "Interview")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 525,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#1e293b"
  }, "Emma Davis")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 525,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#1e293b"
  }, "UX Designer")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 510,
    width: 80,
    height: 24,
    rx: 12,
    fill: "#fee2e2"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 740,
    y: 525,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#dc2626",
    textAnchor: "middle"
  }, "New")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCognitoScreenshot);
export default __webpack_public_path__ + "static/media/cognito-screenshot.82795bc49188f8781acbe2e51828b3f8.svg";
export { ForwardRef as ReactComponent };